import React from 'react';
import styled from 'styled-components';
import config from '../../services/config';
import { humanizeEnvironment, isProductionEnvironment } from '../../utils/environmentHelper';

const BadgeContainer = styled.div`
    background-color: #000000;
    color: #ffffff;
    padding: ${props => props.compact ? '4px 12px' : '6px 16px'};
    font-family: 'Lato', sans-serif;
    font-weight: 600;
    font-size: ${props => props.compact ? '0.75rem' : '0.875rem'};
    text-align: center;
    display: inline-block;
    border-radius: 4px;
    white-space: nowrap;
    ${props => props.position === 'header' && `
        margin-left: 12px;
    `}
    ${props => props.position === 'beside-logo' && `
        flex-shrink: 0;
    `}
`;

/**
 * EnvironmentBadge component displays the current environment name
 * Only shows for non-production environments
 * 
 * @param {string} position - 'header' for main layout (right of logo), 'beside-logo' for login/ferpa/signout
 * @param {boolean} compact - Use smaller padding and font size
 */
const EnvironmentBadge = ({ position = 'header', compact = false }) => {
    const currentEnv = config.currentEnv;

    // Don't show badge for production environments
    if (!currentEnv || isProductionEnvironment(currentEnv)) {
        return null;
    }

    const displayName = humanizeEnvironment(currentEnv);

    return (
        <BadgeContainer position={position} compact={compact}>
            {displayName}
        </BadgeContainer>
    );
};

export default EnvironmentBadge;
